import { SiteStatus } from 'types/Site';

export const StatusOrder: SiteStatus[] = [
    'down',
    'unhealthy',
    'provisioning',
    'pending',
    'healthy',
];

export const UNHEALTHY_STATUSES: SiteStatus[] = ['high', 'medium', 'low'];
